export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14565.2dd5ba28.jpg";